const { createSlice } = require("@reduxjs/toolkit");

const navbarSlice = createSlice({
  name: "nav",
  initialState: {
    isSidebarCollapsed: window.innerWidth >= 768 ? false : true,
    showRequestDemo: false,
    isNavbarCollapsed: true,
    openSections: {
      partners: false,
      compliancy: false,
    },
  },
  reducers: {
    collapseSidebar: (state) => {
      return {
        ...state,
        isSidebarCollapsed: !state.isSidebarCollapsed,
      };
    },
    collapseNavbar: (state) => {
      return {
        ...state,
        isNavbarCollapsed: !state.isNavbarCollapsed,
      };
    },
    toggleRequestDemo: (state) => {
      return {
        ...state,
        showRequestDemo: !state.showRequestDemo,
      };
    },
    toggleSection: (state, action) => {
      const key = action.payload;
      state.openSections[key] = !state.openSections[key];
    },
    closeOpenSections: (state, action) => {
      const keys = action.payload;
      keys.forEach((key) => {
        if (state.openSections[key]) {
          state.openSections[key] = false;
        }
      });
    },
  },
});

export const {
  collapseSidebar,
  toggleRequestDemo,
  collapseNavbar,
  toggleSection,
  closeOpenSections,
} = navbarSlice.actions;

export default navbarSlice.reducer;
